<div class="cv-theme-admin" [nbSpinner]="loading" nbSpinnerStatus="primary">
  @if (loaded) {
  <div class="theme-layout">
    <form [formGroup]="form" novalidate class="theme-form">
      <ul class="field-list">
        <li class="color-row">
          <label for="cv-theme-primary">
            <nb-icon icon="droplet-outline"></nb-icon>
            <span>{{ 'cv.theme.primaryColor' | translate }}</span>
          </label>
          <input nbInput fieldSize="small" maxlength="16" formControlName="primary_color" class="hex-input">
          <input id="cv-theme-primary" type="color" formControlName="primary_color" class="color-row__swatch">
          <span
            class="cv-contrast-warning color-row__warning"
            [class.cv-contrast-warning--hidden]="!(form.value.primary_color && form.value.text_color
                   && isLowContrast(form.value.text_color, form.value.primary_color))"
            [nbTooltip]="'cv.theme.contrastWarning' | translate">
            <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
          </span>
        </li>

        <li class="color-row">
          <label for="cv-theme-accent">
            <nb-icon icon="color-picker-outline"></nb-icon>
            <span>{{ 'cv.theme.accentColor' | translate }}</span>
          </label>
          <input nbInput fieldSize="small" maxlength="16" formControlName="accent_color" class="hex-input">
          <input id="cv-theme-accent" type="color" formControlName="accent_color" class="color-row__swatch">
          <span
            class="cv-contrast-warning color-row__warning"
            [class.cv-contrast-warning--hidden]="!(form.value.accent_color && form.value.text_color
                   && isLowContrast(form.value.text_color, form.value.accent_color))"
            [nbTooltip]="'cv.theme.contrastWarning' | translate">
            <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
          </span>
        </li>

        <li class="color-row">
          <label for="cv-theme-text">
            <nb-icon icon="text-outline"></nb-icon>
            <span>{{ 'cv.theme.textColor' | translate }}</span>
          </label>
          <input nbInput fieldSize="small" maxlength="16" formControlName="text_color" class="hex-input">
          <input id="cv-theme-text" type="color" formControlName="text_color" class="color-row__swatch">
          <span
            class="cv-contrast-warning color-row__warning"
            [class.cv-contrast-warning--hidden]="!(form.value.text_color && isLowContrast(form.value.text_color, '#FFFFFF'))"
            [nbTooltip]="'cv.theme.contrastWarning' | translate">
            <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
          </span>
        </li>

        <li>
          <label for="cv-theme-font">
            <nb-icon icon="edit-2-outline"></nb-icon>
            <span>{{ 'cv.theme.fontFamily' | translate }}</span>
          </label>
          <nb-select id="cv-theme-font" formControlName="font_family" size="small">
            @for (font of fonts; track font) {
              <nb-option [value]="font">{{ font }}</nb-option>
            }
          </nb-select>
        </li>

        <li>
          <label for="cv-theme-sidebar">
            <nb-icon icon="layout-outline"></nb-icon>
            <span>{{ 'cv.theme.sidebarPosition' | translate }}</span>
          </label>
          <nb-select
            id="cv-theme-sidebar"
            formControlName="sidebar_position"
            size="small">
            @for (pos of sidebarPositions; track pos) {
              <nb-option [value]="pos">{{ 'cv.theme.sidebar.' + pos | translate }}</nb-option>
            }
          </nb-select>
        </li>

        <li>
          <label for="cv-theme-template">
            <nb-icon icon="grid-outline"></nb-icon>
            <span>{{ 'cv.theme.template' | translate }}</span>
          </label>
          <nb-select id="cv-theme-template" formControlName="template_id" size="small">
            @for (t of templates; track t.id) {
              <nb-option [value]="t.id">{{ t.name }}</nb-option>
            }
          </nb-select>
        </li>

        <li>
          <label for="cv-theme-default-template">
            <nb-icon icon="image-outline"></nb-icon>
            <span>{{ 'cv.theme.defaultTemplate' | translate }}</span>
          </label>
          <nb-toggle
            id="cv-theme-default-template"
            [checked]="form.value.template_type === 'client'"
            [disabled]="!clientTemplates.length"
            [nbTooltip]="!clientTemplates.length ? ('cv.theme.defaultTemplateNone' | translate) : ''"
            (checkedChange)="onDefaultTemplateToggle($event)">
          </nb-toggle>
        </li>

        @if (form.value.template_type === 'client') {
          <li class="field-list-row-top">
            <label for="cv-theme-default-template-pick">
              <nb-icon icon="image-outline"></nb-icon>
              <span>{{ 'cv.theme.defaultTemplatePick' | translate }}</span>
            </label>
            @if (clientTemplates.length) {
              <nb-select
                id="cv-theme-default-template-pick"
                formControlName="client_cv_template_id"
                size="small">
                @for (t of clientTemplates; track t.id) {
                  <nb-option [value]="t.id">{{ t.name }}</nb-option>
                }
              </nb-select>
            } @else {
              <span class="theme-preview-empty">{{ 'cv.theme.defaultTemplateNone' | translate }}</span>
            }
          </li>
        }

        <li>
          <label for="cv-theme-header-photo">
            <nb-icon icon="person-outline"></nb-icon>
            <span>{{ 'cv.theme.headerPhoto' | translate }}</span>
          </label>
          <nb-toggle
            id="cv-theme-header-photo"
            formControlName="header_photo">
          </nb-toggle>
        </li>

        <li>
          <label for="cv-theme-skills-format">
            <nb-icon icon="list-outline"></nb-icon>
            <span>{{ 'cv.theme.skillsFormat' | translate }}</span>
          </label>
          <nb-select
            id="cv-theme-skills-format"
            formControlName="skills_format"
            size="small">
            <nb-option value="inline">{{ 'cv.theme.skills.inline' | translate }}</nb-option>
            <nb-option value="bullets">{{ 'cv.theme.skills.bullets' | translate }}</nb-option>
          </nb-select>
        </li>

        <li>
          <label for="cv-theme-experience-layout">
            <nb-icon icon="briefcase-outline"></nb-icon>
            <span>{{ 'cv.theme.experienceLayout' | translate }}</span>
          </label>
          <nb-select
            id="cv-theme-experience-layout"
            formControlName="experience_layout"
            size="small">
            <nb-option value="role_first">{{ 'cv.theme.experience.roleFirst' | translate }}</nb-option>
            <nb-option value="date_first">{{ 'cv.theme.experience.dateFirst' | translate }}</nb-option>
          </nb-select>
        </li>

        <li>
          <label for="cv-theme-references-line">
            <nb-icon icon="message-square-outline"></nb-icon>
            <span>{{ 'cv.theme.referencesLine' | translate }}</span>
          </label>
          <nb-select
            id="cv-theme-references-line"
            formControlName="references_line"
            size="small">
            <nb-option value="on">{{ 'cv.theme.references.on' | translate }}</nb-option>
            <nb-option value="off">{{ 'cv.theme.references.off' | translate }}</nb-option>
            <nb-option value="custom">{{ 'cv.theme.references.custom' | translate }}</nb-option>
          </nb-select>
        </li>

        @if (form.value.references_line === 'custom') {
          <li class="field-list-row-top">
            <label for="cv-theme-references-custom">
              <nb-icon icon="edit-outline"></nb-icon>
              <span>{{ 'cv.theme.referencesCustomText' | translate }}</span>
            </label>
            <textarea
              id="cv-theme-references-custom"
              nbInput
              fieldSize="small"
              rows="2"
              maxlength="500"
              rawpaste
              formControlName="references_custom_text"
              [placeholder]="'cv.theme.referencesCustomPlaceholder' | translate"
              class="custom-refs-input"></textarea>
          </li>
        }
      </ul>

      <div class="actions-row">
        <button
          nbButton
          status="primary"
          size="small"
          type="button"
          shape="semi-round"
          (click)="onSave()"
          [disabled]="saving || loading"
          [nbSpinner]="saving"
          nbSpinnerStatus="control"
          nbSpinnerSize="tiny">
          <nb-icon icon="save-outline"></nb-icon>
          {{ 'cv.theme.save' | translate }}
        </button>
      </div>
    </form>

    <aside class="theme-preview" [nbSpinner]="previewLoading" nbSpinnerSize="tiny" nbSpinnerStatus="primary">
      <header class="theme-preview-head">
        <span class="theme-preview-label">{{ 'cv.theme.previewLabel' | translate }}</span>
      </header>
      @if (previewError) {
        <div class="theme-preview-error">
          <nb-icon icon="alert-triangle-outline" status="danger"></nb-icon>
          <span>{{ previewError }}</span>
        </div>
      } @else if (previewHtml) {
        <div class="theme-preview-stage">
          <iframe
            class="theme-preview-frame"
            title="CV live preview"
            sandbox="allow-same-origin"
            [srcdoc]="previewHtml">
          </iframe>
        </div>
      } @else {
        <div class="theme-preview-empty">
          {{ 'cv.theme.previewLoading' | translate }}
        </div>
      }
    </aside>
  </div>
  }
</div>
